<template>
	<div class="overview">
		<Create v-if="(add && !isViewer) || (!cardsAvailable && !isViewer)" :reset-add="resetAdd" :multi="false" :is-overview="true" />
		<Edit v-if="edit && cardsAvailable && !isViewer" :reset-edit="resetEdit" :is-overview="true" />
		<v-layout class="overview" justify-center>
			<v-flex v-if="cardsAvailable && !edit && !add" xs12>
				<v-card>
					<v-container fluid grid-list-md>
						<v-layout row wrap>
							<v-flex v-for="card in cards" :key="card.title" xs12 sm6 md4 lg3>
								<v-card :to="card.link">
									<v-img :src="card.src" height="200px">
										<v-container fill-height fluid pa-2>
											<v-layout fill-height>
												<v-flex xs12 align-end flexbox>
													<span class="headline white--text" v-text="card.title"></span>
												</v-flex>
											</v-layout>
										</v-container>
									</v-img>
								</v-card>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card>
			</v-flex>
			<v-speed-dial v-if="!isViewer" v-model="fab" left bottom fixed direction="top" transition="slide-y-reverse-transition">
				<template v-slot:activator>
					<v-btn v-model="fab" :dark="fab" fab>
						<v-icon>settings</v-icon>
						<v-icon>close</v-icon>
					</v-btn>
				</template>
				<v-btn v-if="!add && !edit && cardsAvailable" fab dark small color="green" @click="edit = !edit">
					<v-icon>edit</v-icon>
				</v-btn>
				<v-btn v-if="!add && !edit" fab dark small color="indigo" @click="add = !add">
					<v-icon>add</v-icon>
				</v-btn>
				<v-btn v-if="add || edit" fab dark small color="indigo" @click="update()">
					<v-icon>grid_on</v-icon>
				</v-btn>
			</v-speed-dial>
		</v-layout>
	</div>
</template>

<script>
import Create from '@/components/Create.vue'
import Edit from '@/components/Edit.vue'
export default {
	name: 'Overview',
	components: {
		Create,
		Edit
	},
	data: () => ({
		add: false,
		edit: false,
		fab: false
	}),
	computed: {
		isViewer() {
			return this.$store.state.user.type == 'viewer'
		},
		cards() {
			return this.$store.state.cards
		},
		cardsAvailable() {
			return this.$store.state.cards.length > 0
		}
	},
	mounted() {
		this.$store.dispatch('getVacations')
	},
	methods: {
		goto(link) {
			this.$router.push(link)
		},
		resetEdit() {
			this.edit = false
		},
		resetAdd() {
			this.add = false
		},
		update() {
			this.add = false
			this.edit = false
			this.$store.dispatch('update', {
				items: this.cards,
				table: 'vacation'
			})
		}
	}
}
</script>
